let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("LOg5S")).then(() => parcelRequire('93ddA'));